export const BI_ORIGIN = 'add_panel';
